export default __webpack_public_path__ + "static/ccl-4-adcd3fa0bd43968507911f965152200e.png";